import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth19postPostScreenTruthGrantsResponseSchema = jsonObject
export type tcpscreentruth19postPostScreenTruthGrantsResponse = z.infer<typeof tcpscreentruth19postPostScreenTruthGrantsResponseSchema>
